import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export type FieldProps = {
  as: React.ReactElement;
  subFieldName: string;
  placeholder?: string;
  label?: string;
  [key: string]: any;
};

export const Field: React.FC<FieldProps> = ({ subFieldName, as: Component, placeholder, label, ...rest }) => {
  const { control } = useFormContext();
  const { fieldNamesPrefix, mode } = useAddressContext();

  const name = `${fieldNamesPrefix}.${subFieldName}`;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            {React.cloneElement(Component, {
              field, // CustomTextField specification
              label,
              ...(mode === AddressMode.MANUAL && { placeholder }),
              error,
              fieldVariant: FieldVariant.form,
              inputRef: field.ref,
              ...rest,
            })}
          </>
        );
      }}
    />
  );
};
